import { CrmEntityType } from '@prisma/client';
import { uniqueChunks } from './chunks';
import { CrmSyncRecordClient } from './types';

/** The only CrmSyncRecord deletion transition, owned by data-integrity. */
export async function deleteRecordsByCrmObjectId({
  crmObjectIds,
  entityType,
  prisma,
}: {
  prisma: CrmSyncRecordClient;
  entityType: CrmEntityType;
  crmObjectIds: string[];
}): Promise<number> {
  let count = 0;

  for (const ids of uniqueChunks(crmObjectIds)) {
    const result = await prisma.crmSyncRecord.deleteMany({
      where: { crmObjectId: { in: ids }, entityType },
    });
    count += result.count;
  }

  return count;
}

/** Retires company mappings so discovery does not recreate intentionally archived companies. */
export async function retireCompanyRecordsByCrmObjectId({
  crmObjectIds,
  prisma,
}: {
  prisma: CrmSyncRecordClient;
  crmObjectIds: string[];
}): Promise<number> {
  let count = 0;

  for (const ids of uniqueChunks(crmObjectIds)) {
    const result = await prisma.crmSyncRecord.updateMany({
      data: { crmObjectId: null, isPlatformDeleted: false, isTerminal: true },
      where: { crmObjectId: { in: ids }, entityType: CrmEntityType.COMPANY },
    });
    count += result.count;
  }

  return count;
}
